import { useQuery } from "react-query";
import { HasLabel } from "../../api/interfaces/has-label.interface";
import { QueryKeys } from "../../enums";
import { useAppServices } from "../../hooks/useAppServices";
import { LeaderBoard } from "../LeaderBoard";
import ReactGA from "react-ga4";
import { useParams } from "react-router-dom";
import styles from "./styles.module.css";
import { LeaderboardLoadingState } from "../LoadingState";
import { LabelNotFoundState } from "../LabelNotFoundState";
import { EmptyLeaderboardState } from "../EmptyLeaderboardState";
import { Header } from "../Header";
import { useTranslation } from "react-i18next";
import { FETCH_INTERVAL_MS } from "../common/constants";

export function LeaderboardPage() {
  const params = useParams<HasLabel>();
  const { leaderboardService } = useAppServices();
  const { t } = useTranslation();

  const { data, isLoading, dataUpdatedAt } = useQuery({
    queryKey: QueryKeys.Leaderboard,
    queryFn: () => {
      ReactGA.send({
        hitType: "pageview",
        label: params.label,
        action: "screen_view",
      });
      return leaderboardService.getLeaderBoard(params.label ?? "");
    },
    refetchInterval: FETCH_INTERVAL_MS,
  });

  const getHeaderTitle = () => {
    if (isLoading) {
      return t("loadingState.headerTitle");
    } else {
      if (data?.status.code === 404) {
        return t("noLabelState.headerTitle");
      } else if (data?.status && data?.status.code > 400) {
        return t("mainTitle");
      } else {
        return data?.payload.title || "";
      }
    }
  };

  const renderLeaderboard = () => {
    if (isLoading) {
      return <LeaderboardLoadingState />;
    }
    if (data?.status.code === 404) {
      return <LabelNotFoundState />;
    }
    if (data?.status && data?.status.code > 400) {
      return <EmptyLeaderboardState />;
    }
    if (data?.payload) {
      return <LeaderBoard payload={data?.payload} />;
    }
  };

  return (
    <div className={styles.leaderboardPage}>
      <Header
        title={getHeaderTitle()}
        subtitle={data?.payload?.subtitle}
        rightLogo={data?.payload?.rightLogo}
        countdownProps={{
          showCountdown: !!data?.payload,
          lastUpdatedAt: dataUpdatedAt ?? 0,
        }}
      />
      {renderLeaderboard()}
    </div>
  );
}
